import styles from "./PlainButton.module.css";

interface PlainButtonProps {
  label: string;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

function PlainButton(props: PlainButtonProps) {
  return (
    <button
      className={styles.plainButton}
      disabled={props.disabled}
      onClick={(event) => {
        event.preventDefault();
        props.onClick?.(event);
      }}
    >
      {props.label}
    </button>
  );
}

export { PlainButton };
